import React from 'react'

const SvgComponent = props => (
  <svg viewBox="231 321 150 150" {...props} fill="currentColor">
    <path d="M357.5 447.5h-.1V344.8l-36.6-10.6-66.2 24.8-.2.1v74.2l22.6-8.8v-60.4l43.8-10.5-.2 88.8-66.2-9.1 66.2 24.5 36.8-10.2v-.1" />
  </svg>
)

export default SvgComponent
